module.exports = __webpack_public_path__ + "img/位图.9207f228.png";